import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { ShowMore } from 'ha/ui.legacy/ShowMore';

interface Props {
  children: string;
  maxLength?: number;
  className?: string;
  preWrap?: boolean;
  ellipsis?: boolean;
}

const useStyles = makeStyles()(() => ({
  breakWord: {
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  preWrap: {
    whiteSpace: 'pre-wrap',
  },
}));

const LongParagraphInternal: React.FC<Props> = ({
  children,
  className = '',
  maxLength = 500,
  preWrap = false,
  ellipsis = true,
}) => {
  const { classes, cx } = useStyles();

  const [showMore, setShowMore] = React.useState(true);
  const isLong = children.length > maxLength;

  const handleShowMoreClick = React.useCallback(() => {
    setShowMore(prevShowMore => !prevShowMore);
  }, []);

  return (
    <p
      className={cx(classes.breakWord, preWrap && classes.preWrap, className)}
      data-test-locator="Long Paragraph"
    >
      {isLong && showMore
        ? `${children.slice(0, maxLength)}${ellipsis ? '...' : ''}`
        : children}
      {isLong ? (
        <ShowMore
          showMore={showMore}
          handleClick={handleShowMoreClick}
          dataTestLocator="Long Paragraph Readmore"
        />
      ) : null}
    </p>
  );
};

const LongParagraph = React.memo(LongParagraphInternal);
export { LongParagraph };
